 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"777cf710","2":"fe96cebbab7a334b2c2ee8ff25a2c512bfed88e7","3":"styles","4":"6a5b63beb3a7c47127250282894c4955f6a45e81","5":"357c8f200313c55e486537d4bdec0fcd0918b3e3","6":"5bce031b255deead956279c61f294e6674226f0e","10":"component---node-modules-gatsby-plugin-offline-app-shell-js","11":"component---src-pages-404-js","12":"component---src-pages-ai-js","13":"component---src-pages-blog-js","14":"component---src-pages-cozumler-enerji-yonetim-sistemi-js","15":"component---src-pages-cozumler-js","16":"component---src-pages-cozumler-toplam-ekipman-verimliligi-js","17":"component---src-pages-cozumler-uretim-izleme-sistemi-js","18":"component---src-pages-cozumler-yapay-zeka-destekli-uretim-js","19":"component---src-pages-demo-js","20":"component---src-pages-iletisim-js","21":"component---src-pages-index-js","22":"component---src-pages-is-ve-zaman-etudu-egitim-kampanyasi-js","23":"component---src-pages-kobigel-js","24":"component---src-pages-moduller-izleme-ve-analiz-gercek-zamanli-izleme-js","25":"component---src-pages-moduller-izleme-ve-analiz-raporlama-servisleri-js","26":"component---src-pages-moduller-izleme-ve-analiz-veri-analizi-js","27":"component---src-pages-moduller-js","28":"component---src-pages-moduller-kullanici-arayuzu-rest-api-js","29":"component---src-pages-moduller-kullanici-arayuzu-web-js","30":"component---src-pages-moduller-uretim-zekasi-istatistiksel-proses-kontrolu-js","31":"component---src-pages-moduller-uretim-zekasi-makine-ogrenimi-js","32":"component---src-pages-moduller-uretim-zekasi-proses-analizi-js","33":"component---src-pages-moduller-uretim-zekasi-proses-optimizasyonu-js","34":"component---src-pages-moduller-veri-ve-kontrol-gecmise-donuk-veri-kaydi-hizmeti-js","35":"component---src-pages-moduller-veri-ve-kontrol-nesnelerin-interneti-iot-js","36":"component---src-pages-moduller-veri-ve-kontrol-veri-toplama-servisleri-js","37":"component---src-pages-moduller-yonetim-bakim-ve-servis-yonetimi-js","38":"component---src-pages-moduller-yonetim-ekipman-yonetimi-ve-oee-js","39":"component---src-pages-moduller-yonetim-enerji-yonetimi-js","40":"component---src-pages-moduller-yonetim-gorev-yonetimi-js","41":"component---src-pages-moduller-yonetim-is-emri-planlamasi-js","42":"component---src-pages-moduller-yonetim-kalite-yonetimi-js","43":"component---src-pages-moduller-yonetim-kullanici-yonetimi-js","44":"component---src-pages-moduller-yonetim-kural-ve-bildirim-yonetimi-js","45":"component---src-pages-moduller-yonetim-recete-yonetimi-js","46":"component---src-pages-moduller-yonetim-tuketim-yonetimi-js","47":"component---src-pages-nasil-calisiyoruz-js","48":"component---src-pages-rehber-js","49":"component---src-pages-retmes-hakkinda-js","50":"component---src-pages-success-js","51":"component---src-templates-blog-template-js","52":"component---src-templates-default-template-js"}[chunkId]||chunkId) + "-" + {"0":"64ba267ba85fdf9838b0","1":"7df4cff8823f19a3d8fb","2":"23d1cb830bd9d4e14689","3":"8d3db5124725dcff78a7","4":"3757b8b010c55b27a888","5":"de2021cbcda2c1b95828","6":"f7118415be512fb0eaeb","10":"80b6a3089d89cde7652d","11":"55550523d7a28d1ccf9a","12":"0d435e8948b01dc5865f","13":"fe737882b976cc0c449c","14":"e4490000ff67c5d82d2e","15":"d50b9b366a0f5ba7aa21","16":"beca9ae53cf570d6ce1f","17":"b228780dd30a28074ec6","18":"c11d8884fd2f6dd31d3c","19":"bbaa0904bcb5d6e6c50d","20":"0752818576d7a57b045e","21":"8e822269a1f488abcd0d","22":"27de83408289d3c1d954","23":"a03300c71beeb7736a2f","24":"afc4b79686ec99931cba","25":"d57857cb7a647d2d2297","26":"c6d93bec9cf72c27dc9e","27":"7fc10dfea960a366bf09","28":"a4d9c403149325dcf556","29":"e2406f1d64642a52b9f7","30":"2a92c48b0fb20ededbdc","31":"ca3d21df04a966673dae","32":"386b3bb0806b445a04bd","33":"12f57feba6fd4892fbe5","34":"5d69fbbda4e8dddbabf6","35":"2d5d5802513ee19c1958","36":"68555cfcabb01e5011fc","37":"c980e1e36ad4176f9a26","38":"227a944a0a644f925f9f","39":"af6ecf2a0a88f8d0b3bc","40":"48d6e2c0e696c47b28b7","41":"d67ca24684f22a4b10f3","42":"6f2ab13aace9d2fe6118","43":"187f49a7ddf728b33dea","44":"8df13b6b19c9def9b1c0","45":"3999e4277c0a3b757b89","46":"bc17a9652b416a39331c","47":"bbf86a472c2f0350026e","48":"cf3180a2ed159f19817a","49":"03f49de7f5112b66b633","50":"cef1786d1f5db00c0086","51":"966f0ca057755c4d6b84","52":"abc569d6dadf70c7948f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"1bfc9850","1":"777cf710","2":"fe96cebbab7a334b2c2ee8ff25a2c512bfed88e7","3":"styles","4":"6a5b63beb3a7c47127250282894c4955f6a45e81","5":"357c8f200313c55e486537d4bdec0fcd0918b3e3","6":"5bce031b255deead956279c61f294e6674226f0e","10":"component---node-modules-gatsby-plugin-offline-app-shell-js","11":"component---src-pages-404-js","12":"component---src-pages-ai-js","13":"component---src-pages-blog-js","14":"component---src-pages-cozumler-enerji-yonetim-sistemi-js","15":"component---src-pages-cozumler-js","16":"component---src-pages-cozumler-toplam-ekipman-verimliligi-js","17":"component---src-pages-cozumler-uretim-izleme-sistemi-js","18":"component---src-pages-cozumler-yapay-zeka-destekli-uretim-js","19":"component---src-pages-demo-js","20":"component---src-pages-iletisim-js","21":"component---src-pages-index-js","22":"component---src-pages-is-ve-zaman-etudu-egitim-kampanyasi-js","23":"component---src-pages-kobigel-js","24":"component---src-pages-moduller-izleme-ve-analiz-gercek-zamanli-izleme-js","25":"component---src-pages-moduller-izleme-ve-analiz-raporlama-servisleri-js","26":"component---src-pages-moduller-izleme-ve-analiz-veri-analizi-js","27":"component---src-pages-moduller-js","28":"component---src-pages-moduller-kullanici-arayuzu-rest-api-js","29":"component---src-pages-moduller-kullanici-arayuzu-web-js","30":"component---src-pages-moduller-uretim-zekasi-istatistiksel-proses-kontrolu-js","31":"component---src-pages-moduller-uretim-zekasi-makine-ogrenimi-js","32":"component---src-pages-moduller-uretim-zekasi-proses-analizi-js","33":"component---src-pages-moduller-uretim-zekasi-proses-optimizasyonu-js","34":"component---src-pages-moduller-veri-ve-kontrol-gecmise-donuk-veri-kaydi-hizmeti-js","35":"component---src-pages-moduller-veri-ve-kontrol-nesnelerin-interneti-iot-js","36":"component---src-pages-moduller-veri-ve-kontrol-veri-toplama-servisleri-js","37":"component---src-pages-moduller-yonetim-bakim-ve-servis-yonetimi-js","38":"component---src-pages-moduller-yonetim-ekipman-yonetimi-ve-oee-js","39":"component---src-pages-moduller-yonetim-enerji-yonetimi-js","40":"component---src-pages-moduller-yonetim-gorev-yonetimi-js","41":"component---src-pages-moduller-yonetim-is-emri-planlamasi-js","42":"component---src-pages-moduller-yonetim-kalite-yonetimi-js","43":"component---src-pages-moduller-yonetim-kullanici-yonetimi-js","44":"component---src-pages-moduller-yonetim-kural-ve-bildirim-yonetimi-js","45":"component---src-pages-moduller-yonetim-recete-yonetimi-js","46":"component---src-pages-moduller-yonetim-tuketim-yonetimi-js","47":"component---src-pages-nasil-calisiyoruz-js","48":"component---src-pages-rehber-js","49":"component---src-pages-retmes-hakkinda-js","50":"component---src-pages-success-js","51":"component---src-templates-blog-template-js","52":"component---src-templates-default-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"3869de4939c941d1e153","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
